var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pagefra',[_c('div',{directives:[{name:"loading",rawName:"v-loading.lock",value:(_vm.loading),expression:"loading",modifiers:{"lock":true}}],staticClass:"displayAnalysis",attrs:{"element-loading-background":"rgba(0, 0, 0, 0.1)"}},[_c('iframe',{attrs:{"title":"","src":_vm.src},on:{"load":function($event){return _vm.loaded()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }